/* eslint-disable max-len */
import { parse } from 'qs';
import { getSystemInfo } from '@/lib/bridge/util/env';
import { storage } from '@/utils/storage';

/**
 * 是否浏览器运行时
 * @returns
 */
export const isBrowserRuntime = () => {
  return typeof window !== 'undefined';
};
export const getCurWifi = () => {
  if (!isBrowserRuntime()) return '';

  return `${navigator?.connection?.type || ''}_${navigator?.connection?.effectiveType || ''}_${navigator?.connection?.downlink || ''}Mb/s_${navigator?.connection?.rtt || ''}ms `;
};
export const isAndroid = () => {
  if (!isBrowserRuntime()) return false;

  const ua = navigator.userAgent.toLowerCase();

  return /android|adr/g.test(ua);
};

export const isWeixin = () => {
  if (!isBrowserRuntime()) return false;

  const ua = navigator.userAgent.toLowerCase();

  return /micromessenger|wexin|wechat/g.test(ua);
};

export const isQQ = () => {
  if (!isBrowserRuntime()) return false;

  const ua = navigator.userAgent.toLowerCase();

  return /qq/g.test(ua);
};
//获取当前浏览器语言
export const getCurLanguage = () => {
  if (!isBrowserRuntime()) return false;
  const curLanguage = storage.getItem('language');
  const ua = navigator.language;

  const language = ua?.slice(0, 3);
  //当前后台配置已支持的语言  de pt fr es id
  const arr = [
    'en',
    'pt',
    'de',
    'pt',
    'fr',
    'es',
    'id',
    'hi',
    'ru',
    'ms',
    'nl',
    'ja',
    'vi',
    'ko',
    'tr',
    'th',
    'pl',
    'uk',
    'fil',
    'ro',
    'sv',
    'cs',
    'hu',
    'el',
    'he',
    'da',
    'fi',
    'no'
  ];
  if (curLanguage) {
    //已手动设置了语言
    return curLanguage;
  } else {
    //未设置多语言
    return arr.indexOf(language) == -1 ? 'en' : language;
  }
};
export const isWeixinOrQQ = () => {
  return isWeixin() || isQQ();
};

export function getUrlParams(key) {
  if (typeof window === 'undefined') return '';

  const { search } = window.location;
  const params = parse(search, { ignoreQueryPrefix: true, decoder: (str) => str });
  return key ? params[key] : params;
}

export const generateRandomId = () => {
  const rand = 1000 + (Math.floor(Math.random() * /* uint32 */ 4294967296) % 8999);
  return `${Date.now()}${rand}`;
};

export const generateSessionId = () => {
  const rand = 1000 + (Math.floor(Math.random() * /* uint32 */ 4294967296) % 8999);
  return `${rand}${Math.floor(Date.now() / 1000)}`;
};

/**
 * 是是否 iOS 系统
 * @returns
 */
export const isIOS = () => {
  const u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};

/**
 * 是否移动端
 * @returns
 */
export const isMobile = () => {
  let check = false;

  if (typeof window !== 'object') return false;

  // eslint-disable-next-line func-names
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};

/**
 * 系统信息
 */
export const systemInfo = isBrowserRuntime() ? getSystemInfo() : {};

/**
 * 渠道判断
 * @returns
 */
export const chanChecks = (() => {
  const chan = getUrlParams('chan');

  return {
    is_a: chan && /_a/.test(chan),
    is_1: chan && /_1/.test(chan),
    is_2: chan && /_2/.test(chan),
    is_b: chan && /_b/.test(chan)
  };
})();

/**
 * 根据渠道获取免费消息次数
 * @returns
 */
export const chanFreeCount = (defaultValue) => {
  const chan = getUrlParams('chan');
  if (chan) {
    const regs = /_m(\d+)/;
    const retArr = regs.exec(chan.toLowerCase());
    if (retArr && retArr.length > 1) {
      return parseInt((retArr || [])[1]);
    }
  }
  //如果没有渠道参数 则默认免费4条消息
  return 4;

  return defaultValue;
};

/**
 * 是否先注册后付费渠道
 * @returns
 */
export const chanIsRegPay = () => {
  const chan = getUrlParams('chan');
  if (chan) {
    return chan.indexOf('_regpay') !== -1 ? true : false; // /_regpay\b/.test(chan.toLowerCase());
  }
  return false;
};

/**
 * 为Url携带渠道参数
 * @param {*} url
 * @returns
 */
export const carryUrlChan = (url, isLink = false) => {
  const chan = getUrlParams('chan');

  if (chan && url.indexOf('chan=') === -1) {
    if (isLink) {
      return `${url}${url.includes('?') ? '&' : '?'}chan=${chan}`;
    } else {
      return {
        pathname: url,
        query: {
          chan
        }
      };
    }
  }
  return url;
};

//下载文件
export const downFile = (fileUrl, name) => {
  const x = new XMLHttpRequest();
  x.open('GET', fileUrl, true);
  x.responseType = 'blob';
  x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  x.onload = () => {
    const url = window.URL.createObjectURL(x.response);
    createAndRemove(url, name);
  };
  x.send();
};
export const createAndRemove = (url, fileName) => {
  // 创建隐藏的可下载链接
  var eleLink = document.createElement('a');
  eleLink.download = fileName;
  eleLink.style.display = 'none';
  // 下载内容转变成blob地址
  eleLink.href = url;
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  document.body.removeChild(eleLink);
};
export const getCurOrigin = () => {
  if (!isBrowserRuntime()) return '';

  return window?.location?.origin;
};
